module.exports = __webpack_public_path__ + "static/media/pair-logo.5d4f4bd8.png";